<template>
  <p class="center mt25">
    <span class="line-cross center"><img src="@/assets/img/report_icon.png" alt="报告"></span>
  </p>
</template>

<script>
export default {
  name: 'LineCross',
};
</script>

<style scoped lang="scss">
@mixin linePosition{
  content: '';
  width: 40px;
  height: 1px;
  position: absolute;
  top: 50%;
  margin-top: -1px;
  background: white;
}
.line-cross{
  position: relative;
  &::before{
    left: -45px;
    @include linePosition;
  }
  &::after{
    right: -45px;
    @include linePosition;
  }
}
</style>
